import { n as normalizeComponent, c as createInjector } from './browser-c94fd32b.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'mdi-eye',
  props: {
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: null
    },
    size: {
      type: [Number, String],
      default: 24
    },
    viewBox: {
      type: [String],
      default: '0 0 24 24'
    },
    xmlns: {
      type: String,
      default: 'http://www.w3.org/2000/svg'
    },
    ariaLabel: {
      type: String,
      default: 'Eye icon'
    },
    role: {
      type: String,
      default: 'img'
    },
    title: {
      type: String,
      required: false
    },
    spin: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function(_h, _vm) {
  var _c = _vm._c;
  return _c(
    "span",
    {
      class: [
        _vm.data.staticClass,
        "mdi",
        "mdi-eye",
        _vm.props.spin ? "mdi-spin" : undefined
      ],
      attrs: { role: _vm.props.role, "aria-label": _vm.props.ariaLabel }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            fill: "currentColor",
            width: _vm.props.width || _vm.props.size,
            height: _vm.props.height || _vm.props.size,
            viewBox: _vm.props.viewBox,
            xmlns: _vm.props.xmlns
          }
        },
        [
          _vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
            }
          })
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-8fe7d71c_0", { source: ".mdi > svg {\n  vertical-align: middle;\n}\n.mdi.mdi-spin > svg {\n  -webkit-animation: mdi-spin 2s infinite linear;\n     -moz-animation: mdi-spin 2s infinite linear;\n          animation: mdi-spin 2s infinite linear;\n}\n@-webkit-keyframes mdi-spin {\n0% {\n      -webkit-transform: rotate(0deg);\n         -moz-transform: rotate(0deg);\n              transform: rotate(0deg);\n}\n100% {\n      -webkit-transform: rotate(360deg);\n         -moz-transform: rotate(360deg);\n              transform: rotate(360deg);\n}\n}\n@keyframes mdi-spin {\n0% {\n      -webkit-transform: rotate(0deg);\n         -moz-transform: rotate(0deg);\n              transform: rotate(0deg);\n}\n100% {\n      -webkit-transform: rotate(360deg);\n         -moz-transform: rotate(360deg);\n              transform: rotate(360deg);\n}\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
